import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, FormControl, FormControlLabel, makeStyles, MenuItem, Radio, RadioGroup, Select, TextField, withStyles } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';
import { adminServerInstance } from '../../../../axios/instances';
import ExcelResUpdate from '../ExcelResUpdate';
import moment from 'moment';
import { showAlertSnackbar } from '../../../../reducers/uiSlice';
import { getCurrentWarehouse } from '../../../../utilities/common';
import ExcelDownloadButton from '../../../Common/ExcelDownloadButton';

const InputTextField = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '10px !important',
        },
        width: 200,
        marginLeft: 5
    },
}))(TextField);

const useStyles = makeStyles((theme) => ({
    selectWidth: {
        width: 200
    },
    excelMargin: { 
        marginLeft: 20
    }
}));

function ExcelBoxUpdate(props) {
    const dispatch = useDispatch();
    const {t} = useTranslation('updateToolbox');
    const classes = useStyles();
    let warehouse = getCurrentWarehouse()['name'];

    const [state, setState] = useState(199);
    const [checkedBatch, setCheckedBatch] = useState(false);
    const [subBatch, setSubBatch] = useState('');

    const [loading, setLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [report, setReport] = useState([]);
    const [updated, setUpdated] = useState(0);
    const [subBatchRes, setSubBatchRes] = useState('');
    const [reportExcel, setReportExcel] = useState([]);

    const [isTransshipment, setIsTransshipment] = useState(`0`);


    const handleStateChange = (event) => {
        setState(event.target.value);
    };
    const handleSubBatch = (event) => {
        setSubBatch(event.target.value);
    };
    const handleTransshipmentRadioChange = (e) => {
        setIsTransshipment(e.target.value);
    }

    function uploadFile() {
        setLoading(true);
        let formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('sub_batch', subBatch);
        formData.append('state', state);
        formData.append('action_location', warehouse);
        adminServerInstance.post(
            `/business/checkbagstatusfromexcel`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                timeout: 60000 * 10
            }
        )
        .then((res) => {
            setLoading(false);
            dispatch(showAlertSnackbar({message: t('update_success_message'), type: 'success'}))
            setReport(res.data.data.report);
            setUpdated(res.data.data.updated);
            setSubBatchRes(res.data.data.sub_reference);
            setSelectedFile(undefined);
        })
        .catch((err) => {
            setLoading(false);
            dispatch(showAlertSnackbar({message: err.message || t('update_fail_message'), type: 'error'}))
            setSelectedFile(undefined);
        })
    }

    useEffect(() => {
        if(props.boxUpdate) {
            setSubBatch('');
            setState(199);
            setSelectedFile(undefined);
            setIsTransshipment(`0`);
        }
    }, [props.boxUpdate])
    useEffect(() => {
        if(!checkedBatch) {
            setSubBatch('');
        }
    }, [checkedBatch])
    useEffect(() => {
        if(report.length > 0) {
            let reportExcelCurr = JSON.parse(JSON.stringify(report));
            reportExcelCurr.map((box) => {
                box.eta = moment(box.eta * 1000).format('YYYY-MM-DD HH:mm:ss');
            })
            setReportExcel(reportExcelCurr);
        }
    }, [report])

    return (
        <>
            <input
                color="primary"
                type="file"
                id="button-file"
                onChange={(e) => setSelectedFile(e.target.files[0])}
                style={{display: 'none'}}
            />
            <div 
                style={{
                    display: 'flex'
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    <Select
                        value={state}
                        onChange={handleStateChange}
                        variant="outlined"
                        style={{ width: 340 }}
                    >
                        <MenuItem value={199}>{t('199')}</MenuItem>
                        <MenuItem value={195}>{t('195')}</MenuItem>
                    </Select>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginTop: 5, 
                            marginBottom: 5
                        }}
                    >
                        <span style={{marginRight:20}}>{t('transshipment_confirm')}</span>
                        <RadioGroup 
                            value={isTransshipment} 
                            onChange={handleTransshipmentRadioChange}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center'
                            }}
                        >
                            <FormControlLabel 
                                id='updatetoolbox-boxupdate-transshipment-radio' 
                                value={`0`} 
                                control={<Radio />} 
                                label={t('common:no')} 
                            /> 
                            <FormControlLabel 
                                id='updatetoolbox-boxupdate-notransshipment-radio' 
                                value={`1`} 
                                control={<Radio />} 
                                label={t('common:yes')} 
                            /> 
                        </RadioGroup>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: 10
                        }}
                    >
                        <div 
                            onClick={() => setCheckedBatch(!checkedBatch)}
                            style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Checkbox checked={checkedBatch}></Checkbox>
                            <span>{t('link_batch')}</span>
                        </div>
                        <div>
                            <InputTextField
                                variant='outlined'
                                placeholder={t('input_link_batch')}
                                disabled={!checkedBatch}
                                onChange={handleSubBatch}
                                value={subBatch}
                            />
                        </div>
                    </div>            
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                    }}
                >
                    <div 
                        style={{ 
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <label htmlFor="button-file">
                            <Button
                                variant="contained"
                                className={classes.selectWidth}
                                color="primary"
                                component="span"
                            >
                                {t('select_file')}
                            </Button>
                        </label>
                        <div style={{ marginLeft: 10 }}>
                            {selectedFile ? selectedFile.name : null}
                        </div>
                        <div style={{ display: 'flex'}}>
                            <Button
                                color="primary"
                                variant="contained"
                                component="span"
                                disabled={!selectedFile || loading}
                                style={{ marginLeft: 10 }}
                                onClick={uploadFile}
                            >
                                {t('confirm_lot_update')}
                            </Button>
                            <ExcelDownloadButton
                                rows={reportExcel || []}
                                name={t('box_update_report')}
                                classes={classes}
                            />
                            {
                                loading &&
                                <div className={classes.buttonStyle}>
                                    <CircularProgress color='secondary'/>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div style={{ marginTop: 20 }}>
                    <ExcelResUpdate report={report} updated={updated} subBatch={subBatchRes}/>
                </div>
            </div>
        </>
    );
}

export default ExcelBoxUpdate;